import React from 'react';
import useNewAddonContext from 'contexts/new-addon.context';
import './style.scss';
import PageHeaderText from 'components/base/page-header-text';
const NewAddonPreview = () => {
  const { newAddonData } = useNewAddonContext();
  return (
    <div>
      <PageHeaderText title='Preview New Addon(s)' description='Review add-on details' />
      <div className='grid grid-cols-3 gap-6'>
        {newAddonData?.addons?.map((item: any, index: number) => (
          <div
            key={index}
            className='addon_card rounded-[6px] border border-white px-[14px] py-[10px] text-sm font-[500]'>
            <p>{item.name} </p>
            <p className='text-[#595959] '>₦{item.amount}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NewAddonPreview;
